class JsonComponentCtrl implements ng.IController {
    json: Object;
    niceJson: string;

    constructor(private $filter: ng.IFilterService) {}

    public $onInit(): void {
        this.niceJson = this.$filter('json')(this.json);
    }

    public $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.niceJson = this.$filter('json')(this.json);
    }
}

angular.module('app').component('json', {
    controller: JsonComponentCtrl,
    template: '<pre>{{$ctrl.niceJson}}</pre>',
    bindings: {
        json: '<'
    }
});
